import React from 'react'
import { Translation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import { useForm, Form, Field, WatchField } from '../../../form'
import classNames from 'classnames'
import { Controller } from 'react-hook-form'
import RichTextEditorComponent from './richTextEditor.component'
import { Button, MenuItem } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import LinearProgress from '@material-ui/core/LinearProgress'
import { contractFormValidateLE } from '../../../containers/employer/validate'
import { useSelector } from 'react-redux'

/**
 * @author Huong Nguyen
 */

const styles = (theme) => ({
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  progress: {
    flexGrow: 1
  },
  dialog: {
    backgroundColor: theme.palette.common.dialogBackground
  },
  warning: {
    border: '1px solid red'
  },
  checkbox: {
    marginTop: theme.spacing(3),
    fontSize: '15px',
    fontWeight: '500',
    color: '#808080'
  },
  button: {
    marginTop: '10px'
  },
  radioButton: {
    fontSize: '14px'
  }
})

const defaultValues = {
  salary_model: '',
  amount: '',
  payment_terms: 14,
  isExpensesIncluded: 'no',
  assignment_type: '',
  assignment_begins: new Date(),
  assignment_ends: null,
  content_assignment: '',
  additional_terms: '',
  eng_lang: false
}

const ContractFormComponent = ({
  classes,
  cancelOffer,
  formSubmit,
  showLeItemLoader,
  enableSendOrSignButton,
  setCopyPrevious,
  // openWarningCloseCompleteOfferForm, // action
  closeWarningCloseCompleteOfferForm,
  openWarningCloseCompleteForm, // state
  formLocation,
  signAndSendContract,
  assignmentFormValues,
  addNewAssignment,
  offerFromLightEntre
}) => {
  const language = useSelector((state) => state.language.lang)
  const [isFormEdited, setIsFormEdit] = React.useState(false)
  const [isMissingContentAssignment, setIsMissingContentAssignment] =
    React.useState(false)

  const form = useForm({
    name: 'contractForm',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    resetOnSubmit: false,
    validator: contractFormValidateLE
  })

  const { control, setValue } = form

  function onSubmit(values) {
    if (values?.content_assignment) {
      formSubmit(values, formLocation === 'applicantOffer' ? false : true)
      setIsMissingContentAssignment(false)
      setIsFormEdit(false)
    } else {
      setIsMissingContentAssignment(true)
    }
  }
  return (
    <Translation>
      {(t) => (
        <div>
          <Form {...form}>
            <div className="row"></div>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <Field
                  label={t('employer.lightEntrepreneurs.label5')}
                  name="salary_model"
                  inputType="select"
                  className={classNames(classes.textField, classes.resize)}
                  control={control}
                  onChange={() => {
                    setIsFormEdit(true)
                  }}
                >
                  <MenuItem value="hourly_rate">
                    {t('employer.lightEntrepreneurs.menuItem1')}
                  </MenuItem>
                  <MenuItem value="contract_price">
                    {t('employer.lightEntrepreneurs.menuItem2')}
                  </MenuItem>
                  <MenuItem value="unit_price">
                    {t('employer.lightEntrepreneurs.menuItem3')}
                  </MenuItem>
                  <MenuItem value="commission">
                    {t('employer.lightEntrepreneurs.menuItem4')}
                  </MenuItem>
                </Field>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <Field
                  label={t('employer.lightEntrepreneurs.label14')}
                  name="amount"
                  inputType="textfield"
                  className={classNames(classes.textField, classes.resize)}
                  control={control}
                  onChange={() => {
                    setIsFormEdit(true)
                  }}
                  labelStyle={{ marginTop: '12px' }}
                />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <Field
                  label={t('employer.lightEntrepreneurs.label7')}
                  name="payment_terms"
                  inputType="select"
                  className={classNames(classes.textField, classes.resize)}
                  control={control}
                  onChange={() => {
                    setIsFormEdit(true)
                  }}
                >
                  {_createOverdueItems(t)}
                </Field>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <p style={{ paddingTop: '22px' }}>
                  {t('employer.lightEntrepreneurs.label8')}
                </p>
                <Field
                  name="isExpensesIncluded"
                  inputType="radiogroup"
                  horizontal
                  className={classes.radioButton}
                  options={[
                    {
                      label: t('employer.lightEntrepreneurs.yes'),
                      value: 'yes'
                    },
                    {
                      label: t('employer.lightEntrepreneurs.no'),
                      value: 'no'
                    }
                  ]}
                  control={control}
                  onChange={() => {
                    setIsFormEdit(true)
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <Field
                  label={t('employer.lightEntrepreneurs.label9')}
                  name="assignment_type"
                  inputType="select"
                  className={classNames(classes.textField, classes.resize)}
                  control={control}
                  onChange={(e) => {
                    if (
                      e.target.value === 'until_further_notice' ||
                      e.target.value === 'until_completion'
                    ) {
                      setValue('assignment_ends', null)
                    }
                    setIsFormEdit(true)
                  }}
                  labelStyle={language === 'est' ? { marginTop: '-18px' } : {}}
                >
                  <MenuItem value="until_further_notice">
                    {t('employer.lightEntrepreneurs.menuItem5')}
                  </MenuItem>
                  <MenuItem value="temporary">
                    {t('employer.lightEntrepreneurs.menuItem6')}
                  </MenuItem>
                  {/* <MenuItem value="temporary_with_notice">
                    {t('employer.lightEntrepreneurs.menuItem7')}
                  </MenuItem> */}
                  <MenuItem value="until_completion">
                    {t('employer.lightEntrepreneurs.menuItem8')}
                  </MenuItem>
                </Field>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <Field
                  label={t('employer.lightEntrepreneurs.label10')}
                  name="assignment_begins"
                  inputType="datepicker"
                  className={classNames(classes.textField, classes.resize)}
                  control={control}
                  onChange={() => {
                    setIsFormEdit(true)
                  }}
                  minDate={new Date()}
                  labelStyle={language === 'fi' ? { marginTop: '-10px' } : {}}
                />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <WatchField
                  control={control}
                  fields={['assignment_begins', 'assignment_type']}
                >
                  {(watch) => (
                    <Field
                      label={t('employer.lightEntrepreneurs.label11')}
                      name="assignment_ends"
                      inputType="datepicker"
                      className={classNames(classes.textField, classes.resize)}
                      control={control}
                      onChange={() => {
                        setIsFormEdit(true)
                      }}
                      minDate={watch.assignment_begins}
                      labelStyle={
                        language === 'fi' ? { marginTop: '-10px' } : {}
                      }
                      disabled={watch.assignment_type !== 'temporary'}
                      showPlaceholder={true}
                    />
                  )}
                </WatchField>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3"></div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <Field
                  label={t('employer.lightEntrepreneurs.label15')}
                  name="eng_lang"
                  inputType="checkbox"
                  className={classNames(classes.checkbox)}
                  control={control}
                  onChange={() => {
                    setIsFormEdit(true)
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div
                  style={{
                    padding: '20px 0px 5px 0px',
                    color: isMissingContentAssignment ? 'red' : ''
                  }}
                >
                  {t('employer.lightEntrepreneurs.label12')}
                </div>
                <div
                  className={
                    isMissingContentAssignment
                      ? classNames(classes.warning)
                      : ''
                  }
                >
                  <Controller
                    render={({ field: { value, onChange } }) => {
                      const handleEditorChange = (editorValue) => {
                        onChange(editorValue)
                        setIsFormEdit(true)
                        setIsMissingContentAssignment(false)
                      }
                      return (
                        <RichTextEditorComponent
                          height="200px"
                          value={value}
                          onEditorChange={handleEditorChange}
                        />
                      )
                    }}
                    name="content_assignment"
                    control={control}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div style={{ padding: '20px 0px 5px 0px' }}>
                  {t('employer.lightEntrepreneurs.label13')}
                </div>
                <Controller
                  render={({ field: { value, onChange } }) => {
                    const handleEditorChange = (editorValue) => {
                      onChange(editorValue)
                      setIsFormEdit(true)
                    }
                    return (
                      <RichTextEditorComponent
                        height="200px"
                        value={value}
                        onEditorChange={handleEditorChange}
                      />
                    )
                  }}
                  name="additional_terms"
                  control={control}
                />
              </div>
            </div>
            <div className="row">
              <div className="pull-right" style={{ padding: '15px' }}>
                {/* <Button
                  variant="outlined"
                  className={classes.button}
                  onClick={() => {
                    openWarningCloseCompleteOfferForm()
                  }}
                >
                  {t('employer.lightEntrepreneurs.dialogBtn1')}
                </Button> */}
                {formLocation === 'lightEntrepreneurs' ||
                formLocation === '/dashboard/assignments' ||
                formLocation === 'applicantOffer' ? (
                  <>
                    {' '}
                    <Button
                      variant="outlined"
                      className={classes.button}
                      type="submit"
                    >
                      {t('employer.lightEntrepreneurs.dialogBtn3')}
                    </Button>
                    {/*Draft feature is next build*/}
                    {/* <Button
                      variant="outlined"
                      className={classes.button}
                      disabled={
                        (enableSendOrSignButton ? false : true) || isFormEdited
                      }
                      onClick={() => {
                        signAndSendContract(null, true)
                      }}
                    >
                      {t('employer.lightEntrepreneurs.dialogBtn8')}
                    </Button> */}
                    <Button
                      variant="contained"
                      className={classes.button}
                      disabled={!enableSendOrSignButton || isFormEdited}
                      onClick={() => {
                        // Will send the assignment instead of sign => Assignor sign first
                        // signContractScreen()
                        if (offerFromLightEntre) {
                          addNewAssignment(assignmentFormValues, true) // Add new assignment then offer right away
                        } else {
                          signAndSendContract(
                            null,
                            false,
                            null,
                            formLocation === '/dashboard/assignments'
                              ? true
                              : false
                          )
                        }
                      }}
                    >
                      {t('employer.lightEntrepreneurs.dialogBtn9')}
                    </Button>
                  </>
                ) : null}
                {/* {formLocation === 'applicantOffer' ? (
                  <Button
                    variant="contained"
                    className={classes.button}
                    type="submit"
                  >
                    {t('employer.offerForm.btn2')}
                  </Button>
                ) : null} */}
              </div>
            </div>
            <div className="row">
              <div className="pull-right">
                <p style={{ paddingRight: '15px' }}>
                  {t('employer.lightEntrepreneurs.p4')}
                </p>
              </div>
            </div>
          </Form>
          <Dialog
            open={showLeItemLoader}
            aria-describedby="alert-dialog-description"
            BackdropProps={{
              classes: {
                root: classes.dialog
              },
              style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
            }}
          >
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                style={{ fontSize: '15px', margin: '20px' }}
              >
                {t('employer.lightEntrepreneurs.loader')}
              </DialogContentText>
            </DialogContent>
            <div className={classes.progress}>
              <LinearProgress />
            </div>
          </Dialog>
          <Dialog
            open={openWarningCloseCompleteForm}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            BackdropProps={{
              classes: {
                root: classes.dialog
              },
              style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
            }}
          >
            <DialogTitle id="alert-dialog-title">
              <span style={{ fontSize: '20px' }}>
                {t('employer.lightEntrepreneurs.dialogTitle4')}
              </span>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <span style={{ fontSize: '14px' }}>
                  {t('employer.lightEntrepreneurs.dialogContent4')}
                </span>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <div className="pull-right">
                <Button
                  variant="outlined"
                  className={classes.dialogButton}
                  onClick={closeWarningCloseCompleteOfferForm}
                >
                  {t('employer.lightEntrepreneurs.dialogBtn1')}
                </Button>
                <Button
                  variant="contained"
                  className={classes.dialogButton}
                  onClick={() => {
                    cancelOffer()
                    setCopyPrevious(false)
                  }}
                >
                  {t('employer.lightEntrepreneurs.dialogBtn7')}
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </Translation>
  )
}

// overdue day
const _createOverdueItems = (t) => {
  let overdueItems = []
  for (let i = 0; i <= 60; i++) {
    overdueItems.push(
      <MenuItem key={i} value={i}>
        {`${i} ${t('employer.lightEntrepreneurs.days')}`}
      </MenuItem>
    )
  }
  return overdueItems
}

export default withStyles(styles)(ContractFormComponent)
